import iBS05H_ResultType from '../model/iBS05H_ResultType';
import SensorResultTable from './SensorResultTable';

type propsType = {
    sensorlogs: iBS05H_ResultType[]
}

const COLUMNS = ["no", "app_id", "manufacturer_id", "model", "battery", "hall_sensor", "count", "macaddress", "rssi", "detected", "arrived"];

const SensorLog_iBS05H_Result = (props: propsType) => (
    <SensorResultTable rows={props.sensorlogs} columnKeys={COLUMNS} />
);

export default SensorLog_iBS05H_Result;
